import PaymentBlockPreview from "./PaymentBlockPreview";

export default PaymentBlockPreview;